export default __webpack_public_path__ + "static/media/sentenceswarmup_standard.3380da36.svg";